/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef } from 'ag-grid-community';
import { getCSMasterFinderListItemId } from '../../resources/color-selection-master-finder-list-item.model';

@Injectable()
export class ColorSelectionMasterFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getCSMasterFinderListItemId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'name', headerName: this.translationService.get('lbl_name') },
    ];
  }
}
